import { getMobileOS } from "../common/Util";

function KakaoBlockPage() {
  const currentUrl = window.location.href;

  const handleCopyUrl = () => {
    try {
      navigator.clipboard.writeText(currentUrl);
      alert("URL이 복사되었습니다. 브라우저에 붙여넣기 해주세요.");
    } catch {
      // clipboard API 미지원 시 fallback
      window.prompt("아래 URL을 복사해주세요:", currentUrl);
    }
  };

  const handleOpenExternal = () => {
    const os = getMobileOS();
    if (os === "android") {
      window.location.href = `intent://${currentUrl.replace(
        /^https?:\/\//,
        ""
      )}#Intent;scheme=https;package=com.android.chrome;end`;
    } else {
      handleCopyUrl();
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        padding: "20px",
        textAlign: "center",
        fontFamily: "sans-serif",
      }}
    >
      <p style={{ fontSize: "18px", fontWeight: "bold", color: "#333" }}>
        외부 브라우저에서 열어주세요
      </p>
      <p
        style={{
          fontSize: "14px",
          color: "#666",
          marginTop: "8px",
          lineHeight: "1.6",
        }}
      >
        카카오톡 브라우저에서는 일부 기능이
        <br />
        정상적으로 동작하지 않습니다.
      </p>
      <button
        onClick={handleOpenExternal}
        style={{
          marginTop: "24px",
          padding: "14px 32px",
          backgroundColor: "#005CE2",
          color: "#fff",
          border: "none",
          borderRadius: "8px",
          fontSize: "16px",
          cursor: "pointer",
        }}
      >
        외부 브라우저로 열기
      </button>
      <p style={{ fontSize: "12px", color: "#999", marginTop: "16px" }}>
        또는 우측 상단 ⋮ 메뉴에서
        <br />
        "다른 브라우저로 열기"를 선택해주세요.
      </p>
    </div>
  );
}

export default KakaoBlockPage;
